<!-- Component to display a card with a label and an image -->
<template>
	<div
		:class="[
			'hover:border-accent-400 relative flex min-h-50 min-w-30 cursor-pointer flex-col items-center justify-between rounded-xl border p-4 hover:shadow-xl',
			fullWidth ? 'w-full' : 'w-[160px]',
			active ? 'border-accent-400 shadow-xl' : 'border-white shadow-md',
		]"
	>
		<!-- Image -->
		<div class="flex flex-col items-center">
			<img
				v-if="imageUrl"
				class="max-w-[80px] rounded-full"
				:src="imageUrl"
				:alt="label"
			/>

			<div
				v-else
				class="img-and-background h-[80px] w-[80px] rounded-full bg-gray-400"
			></div>

			<!-- Label -->
			<span class="pt-4 text-center text-base font-normal">
				{{ label }}
			</span>
		</div>
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	label: string
	active?: boolean
	imageUrl?: string
	fullWidth?: boolean
}>()
</script>
